import React from 'react';
import cn from 'clsx';
import styles from './style.module.scss';
import { useTranslation } from '@hooks/index';

interface CreatedUpdatedInfoProps {
    created?: string;
    updated?: string;
    integrationUpdated?: string;
    width?: number;
}

const CreatedUpdatedInfo = ({ created, updated, integrationUpdated, width }: CreatedUpdatedInfoProps) => {
    const { t } = useTranslation();
    const style = width ? { width } : undefined;

    const isThirdMetaColumn = integrationUpdated !== undefined;
    return (
        <div
            className={cn({ 'k-d-flex': !isThirdMetaColumn }, ' k-w-full')}
            data-testid="created-updated-info"
            style={style}
        >
            <div className={cn({ 'k-w-1/2': !isThirdMetaColumn }, 'k-ml-2')}>
                {!!created && (
                    <span className={cn({ 'k-d-flex k-gap-20': isThirdMetaColumn })}>
                        <div className="k-font-medium">{`${t('created')} `}</div>
                        <div className={cn(styles.metaDataText, { 'k-pl-1': isThirdMetaColumn })}>{created}</div>
                    </span>
                )}
            </div>
            <div className={cn({ 'k-w-1/2': !isThirdMetaColumn, 'k-ml-2': isThirdMetaColumn })}>
                {!!updated && (
                    <span className={cn({ 'k-d-flex k-gap-20': isThirdMetaColumn })}>
                        <div className="k-font-medium">{`${t('updated')} `}</div>
                        <div className={styles.metaDataText}>{updated}</div>
                    </span>
                )}
            </div>
            <div className="k-ml-2">
                {!!integrationUpdated && (
                    <span className="k-d-flex k-gap-3">
                        <div className="k-font-medium">{`${t('integrationUpdated')} `}</div>
                        <div className={styles.metaDataText}>{integrationUpdated}</div>
                    </span>
                )}
            </div>
        </div>
    );
};

export default CreatedUpdatedInfo;
